import { apiFetch } from '@app/utils/utils';
import { AdminOverview } from '@app/Overview/types';

export async function getOverview(): Promise<AdminOverview> {
  const res = await apiFetch('/api/admin/metrics/overview');
  if (!res.ok) {
    throw new Error(`Failed to load overview metrics (${res.status})`);
  }
  return res.json();
}
